module.exports = __webpack_public_path__ + "img/banner_2026_birthday.11085caa.jpg";